module.exports = __webpack_public_path__ + "static/media/gif.6057f3c1.gif";